"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tenantInteractionUpdate = exports.tenantInteractionSuccess = exports.tenantInteractionSubFolderList = exports.tenantInteractionSoftDeleteList = exports.tenantInteractionSoftDeleteBulk = exports.tenantInteractionSoftDelete = exports.tenantInteractionRestoreBulk = exports.tenantInteractionRestore = exports.tenantInteractionResponseSubmitReset = exports.tenantInteractionResponseSubmit = exports.tenantInteractionResponseList = exports.tenantInteractionReset = exports.tenantInteractionHardDelete = exports.tenantInteractionFinalUpdate = exports.tenantInteractionFinalSave = exports.tenantInteractionFetchList = exports.tenantInteractionFetch = exports.tenantInteractionError = exports.tenantInteractionDeleteBulk = exports.tenantInteractionCreate = void 0;
var _tenantInteraction = require("./tenantInteraction.constant");
// @flow

// common success
var tenantInteractionSuccess = function tenantInteractionSuccess(actionType, data) {
  return {
    type: _tenantInteraction.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.tenantInteractionSuccess = tenantInteractionSuccess;
var tenantInteractionError = function tenantInteractionError(actionType, error) {
  return {
    type: _tenantInteraction.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * tenantInteraction reset
 * @param payload
 * @returns api response
 * @description this function used to reset states.
 */
exports.tenantInteractionError = tenantInteractionError;
var tenantInteractionReset = function tenantInteractionReset(data) {
  return {
    type: _tenantInteraction.actionTypes.RESET,
    payload: data
  };
};

/**
 * Create
 * @param payload
 * @returns api response
 * @description this function used to Create.
 */
exports.tenantInteractionReset = tenantInteractionReset;
var tenantInteractionCreate = function tenantInteractionCreate(data) {
  return {
    type: _tenantInteraction.actionTypes.CREATE,
    payload: data
  };
};

/**
 * Update
 * @param payload
 * @returns api response
 * @description this function used to Update.
 */
exports.tenantInteractionCreate = tenantInteractionCreate;
var tenantInteractionUpdate = function tenantInteractionUpdate(data) {
  return {
    type: _tenantInteraction.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * Fetch
 * @param payload
 * @returns api response
 * @description this function used to Fetch.
 */
exports.tenantInteractionUpdate = tenantInteractionUpdate;
var tenantInteractionFetch = function tenantInteractionFetch(data) {
  return {
    type: _tenantInteraction.actionTypes.FETCH,
    payload: data
  };
};

/**
 * FetchList
 * @param payload
 * @returns api response
 * @description this function used to FetchList.
 */
exports.tenantInteractionFetch = tenantInteractionFetch;
var tenantInteractionFetchList = function tenantInteractionFetchList(data) {
  return {
    type: _tenantInteraction.actionTypes.FETCH_LIST,
    payload: data
  };
};

/**
 * SoftDelete
 * @param payload
 * @returns api response
 * @description this function used to SoftDelete.
 */
exports.tenantInteractionFetchList = tenantInteractionFetchList;
var tenantInteractionSoftDelete = function tenantInteractionSoftDelete(data) {
  return {
    type: _tenantInteraction.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * HardDelete
 * @param payload
 * @returns api response
 * @description this function used to HardDelete.
 */
exports.tenantInteractionSoftDelete = tenantInteractionSoftDelete;
var tenantInteractionHardDelete = function tenantInteractionHardDelete(data) {
  return {
    type: _tenantInteraction.actionTypes.HARD_DELETE,
    payload: data
  };
};

/**
 * Restore
 * @param payload
 * @returns api response
 * @description this function used to Restore.
 */
exports.tenantInteractionHardDelete = tenantInteractionHardDelete;
var tenantInteractionRestore = function tenantInteractionRestore(data) {
  return {
    type: _tenantInteraction.actionTypes.RESTORE,
    payload: data
  };
};

/**
 * SoftDeleteList
 * @param payload
 * @returns api response
 * @description this function used to SoftDeleteList.
 */
exports.tenantInteractionRestore = tenantInteractionRestore;
var tenantInteractionSoftDeleteList = function tenantInteractionSoftDeleteList(data) {
  return {
    type: _tenantInteraction.actionTypes.SOFT_DELETE_LIST,
    payload: data
  };
};

/**
 * SoftDeleteBulk
 * @param payload
 * @returns api response
 * @description this function used to SoftDeleteBulk.
 */
exports.tenantInteractionSoftDeleteList = tenantInteractionSoftDeleteList;
var tenantInteractionSoftDeleteBulk = function tenantInteractionSoftDeleteBulk(data) {
  return {
    type: _tenantInteraction.actionTypes.SOFT_DELETE_BULK,
    payload: data
  };
};

/**
 * DeleteBulk
 * @param payload
 * @returns api response
 * @description this function used to DeleteBulk.
 */
exports.tenantInteractionSoftDeleteBulk = tenantInteractionSoftDeleteBulk;
var tenantInteractionDeleteBulk = function tenantInteractionDeleteBulk(data) {
  return {
    type: _tenantInteraction.actionTypes.DELETE_BULK,
    payload: data
  };
};

/**
 * RestoreBulk
 * @param payload
 * @returns api response
 * @description this function used to RestoreBulk.
 */
exports.tenantInteractionDeleteBulk = tenantInteractionDeleteBulk;
var tenantInteractionRestoreBulk = function tenantInteractionRestoreBulk(data) {
  return {
    type: _tenantInteraction.actionTypes.RESTORE_BULK,
    payload: data
  };
};

/**
 * FinalSave
 * @param payload
 * @returns api response
 * @description this function used to FinalSave.
 */
exports.tenantInteractionRestoreBulk = tenantInteractionRestoreBulk;
var tenantInteractionFinalSave = function tenantInteractionFinalSave(data) {
  return {
    type: _tenantInteraction.actionTypes.FINAL_SAVE,
    payload: data
  };
};

/**
 * FinalUpdate
 * @param payload
 * @returns api response
 * @description this function used to FinalUpdate.
 */
exports.tenantInteractionFinalSave = tenantInteractionFinalSave;
var tenantInteractionFinalUpdate = function tenantInteractionFinalUpdate(data) {
  return {
    type: _tenantInteraction.actionTypes.FINAL_UPDATE,
    payload: data
  };
};

/**
 * Sub folder list
 * @param payload
 * @returns api response
 * @description this function used to SubFolderList.
 */
exports.tenantInteractionFinalUpdate = tenantInteractionFinalUpdate;
var tenantInteractionSubFolderList = function tenantInteractionSubFolderList(data) {
  return {
    type: _tenantInteraction.actionTypes.SUB_FOLDER_LIST,
    payload: data
  };
};

/**
 * Response list
 * @param payload
 * @returns api response
 * @description this function used to ResponseList.
 */
exports.tenantInteractionSubFolderList = tenantInteractionSubFolderList;
var tenantInteractionResponseList = function tenantInteractionResponseList(data) {
  return {
    type: _tenantInteraction.actionTypes.RESPONSE_LIST,
    payload: data
  };
};

/**
 * Response submit
 * @param payload
 * @returns api response
 * @description this function used to ResponseSubmit.
 */
exports.tenantInteractionResponseList = tenantInteractionResponseList;
var tenantInteractionResponseSubmit = function tenantInteractionResponseSubmit(data) {
  return {
    type: _tenantInteraction.actionTypes.RESPONSE_SUBMIT,
    payload: data
  };
};

/**
 * Response submit reset
 * @param payload
 * @returns api response
 * @description this function used to ResponseSubmit.
 */
exports.tenantInteractionResponseSubmit = tenantInteractionResponseSubmit;
var tenantInteractionResponseSubmitReset = function tenantInteractionResponseSubmitReset(data) {
  return {
    type: _tenantInteraction.actionTypes.RESPONSE_SUBMIT_RESET,
    payload: data
  };
};
exports.tenantInteractionResponseSubmitReset = tenantInteractionResponseSubmitReset;